export enum ActivityRaiseType {
  Detection = 1,
}
